// deploymentsData.jsx
import deployIcon1 from '../../../assets/images/deployment/mento.png';
import deployIcon2 from '../../../assets/images/deployment/autoMailer.png';
import deployIcon3 from '../../../assets/images/deployment/flashy-json.svg';

const deploymentsData = [
  {
    id: 1,
    icon: deployIcon1,
    title: "Mento",
    description: "A Safe Space to Talk, Heal, and Grow Because You Deserve It!",
    link: "https://mento.in/"
  },
  {
    id: 2,
    icon: deployIcon2,
    title: "AutoMeeting Scheduler",
    description: "Where you can schedule the meetings with one click",
    link: "https://auto-meeting-scheduler-two.vercel.app/"
  },
  {
    id: 3,
    icon: deployIcon3,
    title: "Flashy JSON",
    description: "Interactive Graph-Based JSON Visualizer with draggable nodes and infinite canvas",
    link: "https://flashy-json.vercel.app/"
  }
];

export default deploymentsData;